// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__Sg5kX","left":"InfoRow_left__1ABhn"};